import Shape from "shape-entities/types/shape";

const { abs, sin, cos, PI, max, min, round, atan2, atan, sqrt, floor, pow } = Math

export const DarkGrayColor = '#3a3a3a'

export type RGBColorType = {
    r: number
    g: number
    b: number
}

export type HSLColorType = {
    h: number
    s: number
    l: number
}

export type RGBAColorType = {
    r: number
    g: number
    b: number
    a: number
}

/*     rgbToHex(r: number, g: number, b: number) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    hexToRgb = (hex: string) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    } */

export const rgbToHex = (colorRGB: RGBColorType) : string => {
    return "#" + ((1 << 24) + (colorRGB.r << 16) + (colorRGB.g << 8) + colorRGB.b).toString(16).slice(1);
}

export const hexToRgb = (hex: string) : RGBColorType => {
    const res = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
        , (m, r, g, b) => '#' + r + r + g + g + b + b)
        .substring(1).match(/.{2}/g)
        .map(x => parseInt(x, 16))
    return {
        r: res[0],
        g: res[1],
        b: res[2],
    }
}

export const hexToRgba = (hex: string): RGBAColorType => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: result[4] ? parseInt(result[4], 16) : 255,   //a=0 fully transparent, a=255 not transparent at all
    } : null;
}

export const relativeLuminance = (color: RGBColorType) => {
    const a = [color.r, color.g, color.b]
        .map(function (v) {
            const vnorm = v / 255
            return vnorm <= 0.03928 ? vnorm / 12.92 : pow((vnorm + 0.055) / 1.055, 2.4);
        })

    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

export type WCAGType = {
    'AA-large': boolean
    'AA-small' : boolean
    'AAA-large': boolean
    'AAA-small': boolean
}

export function chekContrast(fgHex : string, bgHex : string) : WCAGType {
    const fg = hexToRgb(fgHex)
    const bg = hexToRgb(bgHex)

    const color1luminance = relativeLuminance(fg)
    const color2luminance = relativeLuminance(bg)

    // calculate the color contrast ratio
    const ratio = color1luminance > color2luminance ?
        ((color2luminance + 0.05) / (color1luminance + 0.05)) : ((color1luminance + 0.05) / (color2luminance + 0.05));

    // results depending on WCAG requirements
    return {
        'AA-large': ratio < 1/3,
        'AA-small' : ratio < 1/4.5,
        'AAA-large': ratio < 1/4.5,
        'AAA-small': ratio < 1/7,
    }
}

export function isShapeContrastOk(shape : Shape) : boolean
{
    try {
        const bgColor = shape.background || shape.text_background_color || (['rectangle', 'circle', 'triangle1', 'triangle2', 'dashedFrame', 'polygon', 'bezier', 'line'].includes(shape.type) ? shape.color : null)
        const fgColor = shape.text_color || shape.color

        if (bgColor && fgColor) {
            const res = chekContrast(fgColor, bgColor)

            const isBold = shape.text_fontfamily && (shape.text_fontfamily.toLocaleLowerCase().includes('bold') || shape.text_fontfamily.toLocaleLowerCase().includes('black'))
            const isLarge = isBold && shape.text_fontsize > 19 || shape.text_fontsize > 24

            return isLarge ? res["AA-large"] : res["AA-small"]
        }
    } catch (e) {
        console.error(e)
    }

    return null
}

 export function isLight(hex: string, threshold: number = 127.5): boolean
    {
        const rgba = hexToRgba(hex);
        const hsp = sqrt(.299 * rgba.r * rgba.r + .587 * rgba.g * rgba.g + .114 * rgba.b * rgba.b);

        return (hsp > threshold);
    } 